export const ADD_ITEM_TO_SELECTION = 'add_item_to_selection';
export const CONFIGURE_ITEM_FOR_SELECTION = 'configure_item_for_selection';
export const REMOVE_ITEM_FROM_SELECTION = 'remove_item_from_selection';
export const CONFIRM_CLEAR_SELECTION = 'confirm_clear_selection';
export const SHOW_PLACES_ONLY_MODAL = 'show_places_only_modal';
export const REQUEST_QUOTATION = 'request_quotation';
export const SHOW_MERGE_SELECTIONS_MODAL = 'show_merge_selections_modal';
export const SHOW_REQUEST_QUOTATION_MODAL = 'show_request_quotation_modal';
export const SHOW_SELECTION_TOUR_MODAL = 'show_selection_tour_modal';
